import { ObjectValues } from '~types/typeUtils';

export const LINE_ITEM_TYPE = {
	SERVICE: 'SERVICE',
	INVENTORY: 'INVENTORY',
	MODIFIER: 'MODIFIER',
	BUNDLE: 'BUNDLE',
} as const;
export type LINE_ITEM_TYPE = ObjectValues<typeof LINE_ITEM_TYPE>;

export const ORDER_STATUS = {
	READY_FOR_PROCESSING: 'READY_FOR_PROCESSING',
	DESIGNATED_FOR_PROCESSING_AT_HUB: 'DESIGNATED_FOR_PROCESSING_AT_HUB',
	PROCESSING: 'PROCESSING',
	DROPPED_OFF_AT_HUB: 'DROPPED_OFF_AT_HUB',
	IN_TRANSIT_TO_HUB: 'IN_TRANSIT_TO_HUB',
	RECEIVED_AT_HUB_FOR_PROCESSING: 'RECEIVED_AT_HUB_FOR_PROCESSING',
	HUB_PROCESSING_COMPLETE: 'HUB_PROCESSING_COMPLETE',
	READY_FOR_PICKUP: 'READY_FOR_PICKUP',
	CREATED: 'CREATED',
	COMPLETED: 'COMPLETED',
	CANCELLED: 'CANCELLED',
	EN_ROUTE_TO_CUSTOMER: 'EN_ROUTE_TO_CUSTOMER',
	READY_FOR_DRIVER_PICKUP: 'READY_FOR_DRIVER_PICKUP',
	DRIVER_PICKED_UP_FROM_CUSTOMER: 'DRIVER_PICKED_UP_FROM_CUSTOMER',
	IN_TRANSIT_TO_STORE: 'IN_TRANSIT_TO_STORE',
	HUB_PROCESSING_ORDER: 'HUB_PROCESSING_ORDER',
	// online order form status
	SUBMITTED: 'SUBMITTED',
	READY_FOR_INTAKE: 'READY_FOR_INTAKE',
	DROPPED_OFF_AT_STORE: 'DROPPED_OFF_AT_STORE',
} as const;
export type ORDER_STATUS_TYPE = ObjectValues<typeof ORDER_STATUS>;

export const INVENTORY_ORDER_STATUS = {
	CREATED: 'CREATED',
	COMPLETED: 'COMPLETED',
	CANCELLED: 'CANCELLED',
} as const;
export type INVENTORY_ORDER_STATUS_TYPE = ObjectValues<typeof INVENTORY_ORDER_STATUS>;

export const PRE_INTAKE_ORDER_STATUSES = new Set<
	ORDER_STATUS_TYPE | INVENTORY_ORDER_STATUS_TYPE
>([
	ORDER_STATUS.SUBMITTED,
	ORDER_STATUS.DRIVER_PICKED_UP_FROM_CUSTOMER,
	ORDER_STATUS.READY_FOR_INTAKE,
]);

export const FINISHED_ORDER_STATUSES = new Set<
	ORDER_STATUS_TYPE | INVENTORY_ORDER_STATUS_TYPE
>([ORDER_STATUS.COMPLETED, ORDER_STATUS.CANCELLED]);

export enum orderStatusDisplayValue {
	READY_FOR_PROCESSING = 'Ready for processing',
	PROCESSING = 'Processing',
	READY_FOR_PICKUP = 'Ready for pickup',
	READY_FOR_DRIVER_PICKUP = 'Ready for driver pickup',
	EN_ROUTE_TO_CUSTOMER = 'En route to customer',
	CREATED = 'Created',
	COMPLETED = 'Completed',
	CANCELLED = 'Canceled',
	IN_TRANSIT_TO_STORE = 'Pickup by driver at Hub',
	HUB_PROCESSING_ORDER = 'Start Processing',

	// online order form status
	SUBMITTED = 'Submitted online',
	DRIVER_PICKED_UP_FROM_CUSTOMER = 'En route to store',
	DROPPED_OFF_AT_STORE = 'Dropped off at store',
	READY_FOR_INTAKE = 'Ready for intake',
	MISSED_PICKUP = 'Missed Pickup',
	MISSED_PICKUP_COMPLETED = 'Missed Pickup (Completed)',
	MISSED_PICKUP_CANCELED = 'Missed Pickup (Canceled)',
	MISSED_PICKUP_WAIVED = 'Missed Pickup (Waived)',
	MISSED_PICKUP_FAILED_PAYMENT = 'Missed Pickup (Failed Payment)',
}

export const ONLINE_ORDER_STATUS = {
	SUBMITTED: 'SUBMITTED',
} as const;
export type ONLINE_ORDER_STATUS_TYPE = ObjectValues<typeof ONLINE_ORDER_STATUS>;

export const ORDER_TYPE = {
	ONLINE: 'ONLINE',
	RESIDENTIAL: 'RESIDENTIAL',
	SERVICE: 'SERVICE',
	INVENTORY: 'INVENTORY',
} as const;
export type ORDER_TYPE_VALUE = ObjectValues<typeof ORDER_TYPE>;

export const ORDERABLE_TYPE = {
	TURN: 'Turn',
	SERVICE_ORDER: 'ServiceOrder',
	INVENTORY_ORDER: 'InventoryOrder',
	LAUNDRY_CARD: 'LaundryCard',
} as const;
export type ORDERABLE_TYPE_VALUE = ObjectValues<typeof ORDERABLE_TYPE>;

export const PRICING_TYPE = {
	PER_POUND: 'PER_POUND',
	FIXED_PRICE: 'FIXED_PRICE',
} as const;
export type PRICING_TYPE_VALUE = ObjectValues<typeof PRICING_TYPE>;

export const SERVICE_CATEGORY_TYPE = {
	DRY_CLEANING: 'DRY_CLEANING',
	LAUNDRY: 'LAUNDRY',
	ALTERATIONS: 'ALTERATIONS',
} as const;
export type SERVICE_CATEGORY_TYPE_VALUE = ObjectValues<typeof SERVICE_CATEGORY_TYPE>;

export const SOLD_ITEM_TYPE = {
	INVENTORY_ITEM: 'InventoryItem',
	SERVICE_PRICES: 'ServicePrices',
	MODIFIER: 'Modifier',
	SERVICES_MASTER: 'ServicesMaster',
} as const;
export type SOLD_ITEM_TYPE_VALUE = ObjectValues<typeof SOLD_ITEM_TYPE>;

export const PRICING_TIER_TYPE = {
	COMMERCIAL: 'COMMERCIAL',
	DELIVERY: 'DELIVERY',
} as const;
export type PRICING_TIER_TYPE_VALUE = ObjectValues<typeof PRICING_TIER_TYPE>;

export const INTERNAL_PHOTOS_ARRAY_MAX_LENGTH = 5;

export const EMPTY_NOTE_TEXT = 'None added';
